import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BaseURL from "../../BaseURL/BaseURL";
import { Oval } from "react-loader-spinner";

const Reset = () => {
  const [token, setToken] = useState("");
  const [Password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [Loader, setLoader] = useState(false);
  const [, setApi] = useState([]);

  const Navigate = useNavigate();

  const reset = () => {
    setLoader(true);
    try {
      const data = new FormData();
      data.append("otp", token);
      data.append("email", email);
      data.append("password", Password);

      var config = {
        method: "POST",
        url: `${BaseURL.baseurl}/reset-password`,
        data: data,
      };

      axios(config)
        .then(function (response) {
          console.log(response, "api");
          setApi(response.data.data);
          if (response.data.status === true) {
            setLoader(false);
            Swal.fire({
              title: "Good job! ",
              text: response.data.message,
              icon: "success",
              button: "Ok",
            });
            Navigate("/");
          } else {
            setLoader(false);
            Swal.fire({
              title: "Opps!",
              text: response.data.error,
              icon: "success",
              button: "Ok",
            });
          }
        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  return (
    <>
      <main>
        <div class="bg_color_2">
          <div class="container margin_60_35">
            <div id="login">
              <h1>Reset Password</h1>
              <div class="box_form">
                <form>
                  <h2 className="text-center pb-4 text-theme">
                    Reset Password
                  </h2>
                  <hr />
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Token"
                      onChange={(e) => setToken(e.target.value)}
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="email"
                      class="form-control"
                      placeholder="Your Email"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="password"
                      class="form-control"
                      placeholder="Your password"
                      id="password"
                      name="password"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div class="form-group text-center add_top_20">
                    <button
                      type="button"
                      class="btn-theme w-50 mx-auto d-flex justify-content-center align-items-center"
                      onClick={reset}
                    >
                      {Loader === true ? (
                        <Oval
                          height={30}
                          width={30}
                          color="#fff"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                          ariaLabel="oval-loading"
                          secondaryColor="#4fa94d"
                          strokeWidth={2}
                          strokeWidthSecondary={2}
                        />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            {/* <!-- /login --> */}
          </div>
        </div>
      </main>
    </>
  );
};

export default Reset;
